/** @prettier */
import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from "react-router-dom";
import { Subscription } from "../services/qbankApi";

import './SideBar.css';

type SideBarLink = {
    destination: string,
    displayText: string,
    icon: IconProp,
};

type SideBarProps = {
    links: Array<SideBarLink>,
};

export const SideBar = ({ links }: SideBarProps) => {
    const displayLinks = Array.from(links.entries()).map(([index, value]: [number, SideBarLink]) => {
        return (
            <div className="sidebar-item" key={index}>
                <Link to={value.destination} className="btn-link">
                    <FontAwesomeIcon className="sidebar-icon" icon={value.icon} size="2x"/>
                    <span className="sidebar-text">{value.displayText}</span>
                </Link>
            </div>
        );
    });

    return (
        <div className="sidebar">
            {displayLinks}
        </div>
    );
};

export const AppSideBar = ({ activeSubscription }: { activeSubscription?: Subscription }) => {
    const sideBarLinks = [
        {
            destination: "/dashboard",
            displayText: "Dashboard",
            icon: "tachometer-alt" as IconProp
        }
    ];

    if (activeSubscription?.questionWriter) {
        sideBarLinks.push({
            destination: "/questions",
            displayText: "My Questions",
            icon: "pen-square" as IconProp
        });
    }
    if (activeSubscription?.student) {
        sideBarLinks.push({
            destination: "/tests",
            displayText: "My Tests",
            icon: "list-alt" as IconProp
        });
    }
    if (activeSubscription?.questionAuditor) {
        sideBarLinks.push({
            destination: "/audits",
            displayText: "Audit Questions",
            icon: "check-square" as IconProp
        });
    }

    return SideBar({ links: sideBarLinks});
};

export const StoreSideBar = () => {
    const sideBarLinks = [
        {
            destination: "/store",
            displayText: "Browse",
            icon: "search" as IconProp
        },
        {
            destination: "/dashboard",
            displayText: "Dashboard",
            icon: "tachometer-alt" as IconProp
        }
    ];
    return SideBar({ links: sideBarLinks });
};
